import styled from 'styled-components'
import { slideInUpAndFadeIn } from './animations'

export const AnimatedWrapper = styled.div`
  ${slideInUpAndFadeIn}
`
